/**
 * Sprint 15G — Marketing Simple Copy & Error Translator.
 * Maps internal API errors/terms to user-friendly Spanish messages.
 */

const errorTranslations = {
  'No audience link activo': 'Esta campaña todavía no tiene una lista de leads vinculada.',
  'Preflight failed': 'La revisión encontró puntos que debes corregir antes de probar.',
  'preflight_required': 'Falta ejecutar la revisión de seguridad.',
  'Snapshot stale': 'La lista cambió desde la última revisión. Actualiza para continuar.',
  'snapshot is stale': 'La lista cambió desde la última revisión. Actualiza para continuar.',
  'Provider readiness missing': 'El canal de envío todavía no está conectado.',
  'provider': 'El canal de envío no está configurado. Puedes continuar con simulación.',
  'Delivery run created': 'Prueba preparada.',
  'Campaign status must be approved': 'La campaña necesita estar aprobada antes de programar.',
  'Schedule status must be ready_for_delivery_future': 'La programación necesita estar lista antes de crear una prueba.',
  'Schedule has no audience_snapshot_id': 'Falta crear la copia segura de la lista. Revisa la seguridad primero.',
  'consent': 'Algunos leads no tienen permiso para recibir mensajes por este canal.',
  'Límite': 'Se alcanzó un límite del plan. Contacta soporte para ampliarlo.',
  'blocked': 'Esta acción está bloqueada. Verifica permisos o estado de la campaña.',
  'impersonation': 'No puedes realizar esta acción mientras estás en sesión de impersonación.',
};

const termTranslations = {
  audience: 'Lista de leads',
  contact: 'Lead',
  campaign: 'Campaña',
  snapshot: 'Copia segura de la lista',
  preflight: 'Revisión de seguridad',
  'delivery run': 'Prueba de envío',
  attempt: 'Intento',
  event: 'Registro',
  'consent status': 'Permiso de contacto',
  'opt-out': 'No quiere recibir mensajes',
  'opted_out': 'Sin permiso',
  'opted_in': 'Con permiso',
  'provider readiness': 'Canal conectado',
  'test recipient': 'Contacto de prueba',
  'dry-run': 'Simulación sin envío',
  'dry_run': 'Simulación',
  'test_send': 'Prueba de envío',
  'mass_send': 'Envío masivo',
  draft: 'Borrador',
  approved: 'Aprobada',
  ready_for_review: 'En revisión',
  rejected: 'Rechazada',
  archived: 'Archivada',
  'ready_for_delivery_future': 'Lista para prueba',
  preflight_passed: 'Revisión OK',
  preflight_required: 'Requiere revisión',
};

export function translateMarketingError(detail) {
  if (!detail) return 'Ocurrió un error. Intenta de nuevo.';
  const d = typeof detail === 'string' ? detail : JSON.stringify(detail);
  for (const [key, msg] of Object.entries(errorTranslations)) {
    if (d.toLowerCase().includes(key.toLowerCase())) return msg;
  }
  return d;
}

export function translateTerm(term) {
  if (!term) return '';
  return termTranslations[term.toLowerCase()] || termTranslations[term] || term;
}

export function slugify(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
}

export default { translateMarketingError, translateTerm, slugify, errorTranslations, termTranslations };
